import styles from './styles/Items.list.hierarchy.module.scss';
import React, { useEffect, useState } from 'react';
import { useAlgoliaDataContext } from '../../hooks/useAlgoliaDataContext';
import { useSearchParams } from 'react-router-dom';
import { InputSearch } from './Input.search';
import { ButtonExpandValuesList } from './Button.expandValuesList';
import { ButtonListItem } from './Button.listItem';
import { ButtonExpandHierarchyLvl } from './Button.expandHierarchyLvl';
import { SEARCH_PARAM_KEY_PAGE_NUMBER } from '../../constants/searchParamKeys';
const getFilteredItems = (items, query) => {
    return items.reduce((arr, item) => {
        const filteredItem = {
            ...item,
            subs: item.subs.length > 0 ? getFilteredItems(item.subs, query) : item.subs
        };
        if (filteredItem.subs.length > 0 || filteredItem.label.toLowerCase().includes(query)) {
            arr.push(filteredItem);
        }
        return arr;
    }, []);
};
const checkSearchValueInSubs = (subs, searchValue) => {
    return subs.some(({ label, subs }) => {
        return label.toLowerCase().includes(searchValue) || checkSearchValueInSubs(subs, searchValue);
    });
};
const checkActiveSubs = (activeValues, subs) => {
    return subs.some(sub => {
        return activeValues[sub.facetKey].includes(sub.value) ||
            checkActiveSubs(activeValues, sub.subs);
    });
};
const Item = ({ item: { label, value, count, subs, facetKey }, fConfig, activeValues, itemClickHandler, searchValue }) => {
    const isActive = activeValues[facetKey].includes(value);
    const [subsExpanded, setSubsExpanded] = useState(() => isActive || checkActiveSubs(activeValues, subs));
    useEffect(() => {
        if (fConfig.searchable === undefined)
            return;
        if (searchValue.length < 1) {
            setSubsExpanded(false);
            return;
        }
        if (checkSearchValueInSubs(subs, searchValue)) {
            setSubsExpanded(true);
        }
    }, [searchValue]);
    const itemButton = React.createElement(ButtonListItem, { fConfig: fConfig, fKey: facetKey, label: label, value: value, count: count, activeValues: activeValues[facetKey], itemClickHandler: itemClickHandler, textForHighlight: fConfig.searchable !== undefined ? searchValue : undefined });
    return (React.createElement("li", { className: "pos:r" }, subs.length < 1
        ? itemButton
        : React.createElement(React.Fragment, null,
            React.createElement("div", { className: "d:flex ai:start" },
                itemButton,
                React.createElement(ButtonExpandHierarchyLvl, { expanded: subsExpanded, onClick: () => { setSubsExpanded(!subsExpanded); } })),
            subsExpanded &&
                React.createElement("div", { className: styles.subList },
                    React.createElement(SubItems, { fConfig: fConfig, items: subs, activeValues: activeValues, itemClickHandler: itemClickHandler, searchValue: searchValue })))));
};
const SubItems = ({ fConfig, items, activeValues, itemClickHandler, searchValue }) => {
    return (React.createElement("ul", { className: "list:none" }, items.map(item => {
        return React.createElement(Item, { fConfig: fConfig, item: item, activeValues: activeValues, itemClickHandler: itemClickHandler, searchValue: searchValue, key: item.value });
    })));
};
const Items = ({ fConfig, activeValues, itemClickHandler }) => {
    const [searchValue, setSearchValue] = useState('');
    const [listExpanded, setListExpanded] = useState(false);
    const { hierarchyFacets } = useAlgoliaDataContext();
    let visibleItemsCount = 0;
    const searchValueLower = searchValue.toLowerCase();
    const items = fConfig.searchable === true && searchValueLower.length > 0
        ? getFilteredItems(hierarchyFacets[fConfig.key], searchValueLower)
        : hierarchyFacets[fConfig.key];
    return React.createElement(React.Fragment, null,
        fConfig.searchable &&
            React.createElement(InputSearch, { name: fConfig.name, value: searchValue, setValue: (v) => { setSearchValue(v); } }),
        React.createElement("ul", { "data-cy-test": 'CollectionFilter-ListHierarchy', className: "list:none" }, items.length < 1
            ? React.createElement("li", null, "No results found")
            : (() => {
                const itemElements = [];
                for (const item of items) {
                    if (fConfig.shortList !== undefined &&
                        fConfig.shortList > 0 &&
                        !listExpanded &&
                        fConfig.shortList === visibleItemsCount)
                        break;
                    visibleItemsCount++;
                    itemElements.push(React.createElement(Item, { fConfig: fConfig, item: item, activeValues: activeValues, itemClickHandler: itemClickHandler, searchValue: searchValue, key: item.value }));
                }
                return itemElements;
            })()),
        fConfig.shortList !== undefined &&
            visibleItemsCount >= fConfig.shortList &&
            items.length > fConfig.shortList &&
            React.createElement(ButtonExpandValuesList, { expanded: listExpanded, onClick: () => { setListExpanded(!listExpanded); } }));
};
export const ItemsListHierarchy = ({ fConfig }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const activeValues = {};
    searchParams.delete(SEARCH_PARAM_KEY_PAGE_NUMBER);
    for (let i = 1; i <= fConfig.hierarchy; i++) {
        const lvlKey = `${fConfig.key}_lv${i}`;
        const value = searchParams.get(lvlKey);
        activeValues[lvlKey] = value !== null ? value.split(',') : [];
    }
    const itemClickHandler = (value, key) => {
        if (activeValues[key].includes(value)) {
            activeValues[key] = activeValues[key].filter(v => v !== value);
        }
        else {
            activeValues[key].push(value);
        }
        if (activeValues[key].length < 1) {
            searchParams.delete(key);
        }
        else {
            searchParams.set(key, activeValues[key].join(','));
        }
        searchParams.sort();
        setSearchParams(searchParams);
    };
    return React.createElement(Items, { fConfig: fConfig, activeValues: activeValues, itemClickHandler: itemClickHandler });
};
